import React from 'react';
import FormField from './FormField';

const FormTab = ({ tabConfig, formikProps, employeeData, readOnlyFields = [] }) => {
  const values = formikProps?.values || {};
  const errors = formikProps?.errors || {};
  const touched = formikProps?.touched || {};
  const setFieldValue = formikProps?.setFieldValue;

  return (
    <div className="form-tab">
      <h2 className="tab-title">{tabConfig.title}</h2>

      <div className="fields-container">
        {tabConfig.fields.map((field) => {
          const isReadOnly = readOnlyFields.includes(field.name);

          // Check if field has conditionalRender function. Bypass the hide when
          // the field is read-only so prefilled details (e.g. relation) still show.
          if (field.conditionalRender && typeof field.conditionalRender === 'function') {
            if (!field.conditionalRender() && !isReadOnly) {
              return null;
            }
          }

          if (field.dependsOn) {
            const dependsOnValue = values[field.dependsOn.field];
            if (field.dependsOn.includeIn === "multiselect") {
              if (!Array.isArray(dependsOnValue) || !dependsOnValue.includes(field.dependsOn.value)) {
                return null;
              }
            } else {
              if (dependsOnValue !== field.dependsOn.value) {
                return null;
              }
            }
          }

          return (
            <div key={field.name}>
              <FormField
                field={field}
                value={values[field.name] || ""}
                setFieldValue={setFieldValue}
                error={errors[field.name]}
                touched={touched[field.name]}
                readOnly={isReadOnly}
              />
              
              {/* Show insurance note only for relation field and when members are available */}
              {field.showInsuranceNote && employeeData && employeeData.members_allowed > 0 && (
                <div className="form-insurance-note" style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>
                  <div className="form-insurance-note-content">
                    <svg className="form-info-icon" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <p>
                      You have {employeeData.members_allowed} family member slots available for insurance coverage under your plan.
                    </p>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FormTab;
